import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../styles/admin/NewExamPage.css";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import ImageIcon from "../../../src/image icon.svg"
import CircularProgress from '@mui/material/CircularProgress'


export default function NewExamPage({setActive,setMobileActive,isAdmin}) {
  const { unitId } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("error message");
  const [showMessage, setShowMessage] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [capacityExceeded, setCapacityExceeded] = useState(false);

  const [exam, setExam] = useState({
    id: "",
    name: "",
    unitId: unitId || "",
    uploadDate: null,
    senderId: "",
    finalGrade: 0,
  });

  const [questions, setQuestions] = useState([]);
  const [questionFiles, setQuestionFiles] = useState([]);


  const addQuestion = () => {
    const newQuestion = {
      examId:exam.id,
      questionNumber: questions.length + 1,
      question: "",
      choice1: "",
      choice2: "",
      choice3: "",
      choice4: "",
      choice5: "",
      correctAnswer: null,
      grade: 1,
      image: null,
      photo:false,
    };

    setQuestions([...questions, newQuestion]);
    updateFinalGrade([...questions, newQuestion]);
  };

  const deleteQuestion = (qindex)=>{
    const updatedQuestions = [...questions]
    let updatedFiles = [...questionFiles];
    let toSplice = -1;
    const deletedFileName = updatedQuestions[qindex].question;
    if(updatedQuestions[qindex].photo){
      for(let i = 0 ; i < updatedFiles.length; i++){
        if(updatedFiles[i].fileName === deletedFileName){
          toSplice = i;
          break;
        }
      }
    }
    if(toSplice !== -1 ) updatedFiles.splice(toSplice,1);
    updatedQuestions.splice(qindex,1);
    for(let i = qindex ; i < updatedQuestions.length; i++){
        updatedQuestions[i].questionNumber -=1;
    }
    updateFinalGrade(updatedQuestions);
    setQuestions(updatedQuestions);
    setQuestionFiles(updatedFiles);
  }

  const updateQuestionField = (index, value) => {
    const updated = [...questions];
    updated[index].question = value;
    setQuestions(updated);
  };

  const fileExtension = (file) => {
  const parts = file.name.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

  const handleImageSelect = async (qIndex, e) => {
    const file = e.target.files[0]
    const fileExtension1 = fileExtension(file);
    if(fileExtension1 === ""){
      alert("امتداد الملف غير مقبول");
      return;
    }
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    if (file.size > MAX_SIZE) {
    alert("يجب أن يكن حجم الصورة اقل من 5 ميجا");
    e.target.value = ""; // reset input
    return;
  }
  const UUID = await getUUID();
  const fileName = UUID +'.'+ fileExtension1;
  const updated = [...questions];
  updated[qIndex].image = URL.createObjectURL(file);
  updated[qIndex].question = fileName;
  updated[qIndex].photo = true;
  setQuestions(updated);
  setQuestionFiles([...questionFiles,{fileName:fileName,file:file}]);

};


  const updateChoice = (qIndex, cIndex, value) => {
    const updated = [...questions];
    updated[qIndex][`choice${cIndex + 1}`] = value;
    setQuestions(updated);
  };

  const updateCorrectAnswer = (qIndex, value) => {
    const updated = [...questions];
    updated[qIndex].correctAnswer = updated[qIndex][`choice${value}`];
    setQuestions(updated);
  };

  const updateGrade = (qIndex, value) => {
    const updated = [...questions];
    updated[qIndex].grade = Number(value);
    setQuestions(updated);
    updateFinalGrade(updated);
  };

  const postTheExam = async () => {
    setDisabledButton(true); 
    let message = "";
    questions.map((q,index)=>{
      if(q.question === "" && q.image === null){
        message+= `السؤال رقم ${index+1} ليس لديه سؤال `
      }
      if(q.correctAnswer === "" || q.correctAnswer === null || q.correctAnswer === undefined){
        message+= `السؤال رقم ${index+1} ليس لديه اجابة صحيحة\n`
      }
      return "q";
    })
    if(message !== ""){
      alert(message);
      setDisabledButton(false);
      return;
    }
    if(exam.name === "" || exam.name === null || exam.name === undefined){
      alert("يجب تسمية الاختبار")
      setDisabledButton(false);
      return;
    }
  const formData = new FormData();
  
  formData.append("exam", new Blob(
    [JSON.stringify(exam)],
    { type: "application/json" }
  ));
  formData.append("questions", new Blob(
      [JSON.stringify(questions)],
      { type: "application/json" }
  ));
  questionFiles.forEach(({ fileName, file }) => {
  formData.append(fileName.toString(), file);
});

  try {
    const response = await axios.post(
      `${BASE_URL}/${isAdmin?'teacher':'assistant'}/new-exam`,
      formData,
      {
        withCredentials: true,
      }
    );

    setMessage(response.data);
    setShowMessage(true);
    setDisabledButton(false);
  } catch (error) {
    console.log(error);
    setDisabledButton(false);
    navigate('/');
  }
};

  const updateFinalGrade = (updatedQuestions) => {
    const total = updatedQuestions.reduce((sum, q) => sum + Number(q.grade), 0);
    setExam({ ...exam, finalGrade: total });
  };

  async function getUUID(){
    try{
      const response = await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/UUID`,{withCredentials:true});
      return response.data;
    }catch(error){
      console.log(error);
    }
  }

  const fetchId = async ()=>{
    try{
      const response = await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/UUID`,{withCredentials:true});
      setExam({...exam,id:response.data});
    }catch(error){
      console.log(error);
    }
  }

  useEffect(()=>{
    fetchId();
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
  },[]);

  return (
    <div className="page-container space-y-4">
      <div className="exam-info-card">
        <div><h2 className="new-exam">إختبار جديد</h2></div>
        <div className="exam-info">
        <input
          dir="rtl"
          lang="ar"
          placeholder="اسم الاختبار"
          value={exam.name}
          onChange={(e) => setExam({ ...exam, name: e.target.value })}
        />

        <p className="question-title">{exam.finalGrade}:مجموع الدرجات </p>
        <div className="exam-info-buttons">
          <button className="delete-lesson-button" onClick={()=>navigate(-1)}>إلغاء</button>
          <button 
          disabled={disabledButton}
          onClick={postTheExam}>{disabledButton?<CircularProgress size={20} color="white" />:"نشر الاختبار"}</button>
        </div>
        
        </div>
      </div>

      <div className="space-y-6">
        {questions.map((q, qIndex) => (
          <div key={qIndex} className="question-card">
              <h3 className="question-title"> {q.questionNumber}السؤال رقم </h3>

              {!q.photo ?(
                <div className="image-upload-area">
                <label className="upload-icon">
                  <img style={{height:"30px"}} src={ImageIcon} />
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => handleImageSelect(qIndex, e)}
                  />
                </label>
                <textarea
                    className="question-text"
                    lang="ar"
                    dir="rtl"
                    placeholder="السؤال"
                    value={q.question}
                    onChange={(e) => updateQuestionField(qIndex, e.target.value)}
                  />
              </div>
              ): (
                  <div className="image-preview-container">
                    <img src={q.image} className="question-image-preview" alt="question" />
                  </div>
                )}

              {/* {!q.image ? (
                  <textarea
                    className="question-text"
                    lang="ar"
                    dir="rtl"
                    placeholder="السؤال"
                    value={q.question}
                    onChange={(e) => updateQuestionField(qIndex, e.target.value)}
                  />
                ) : (
                  <div className="image-preview-container">
                    <img src={q.image} className="question-image-preview" alt="question" />
                  </div>
                )} */}

              {/* <textarea
                className="question-text"
                lang="ar"
                dir="rtl"
                placeholder="السؤال"
                value={q.question}
                onChange={(e) =>
                  updateQuestionField(qIndex, e.target.value)
                }
              /> */}

                {[1, 2, 3, 4, 5].map((num, cIndex) => (
                  <div key={cIndex} className="choice-row">
                    <input
                      dir="rtl"
                      lang="ar"
                      className="choice-input"
                      placeholder={`${num}اختيار رقم `}
                      value={q[`choice${num}`]}
                      onChange={(e) =>{
                        const isCorrect = q.correctAnswer === q[`choice${num}`];
                        updateChoice(qIndex, cIndex, e.target.value);
                        if(isCorrect) updateCorrectAnswer(qIndex,num);
                      }
                      }
                    />

                    <input
                      className="choice-input-radio"
                      type="radio"
                      name={`correct-${qIndex}`}
                      checked={q.correctAnswer === q[`choice${num}`]}
                      onChange={() => {updateCorrectAnswer(qIndex, num);}}
                    />
                  </div>
                ))}

                

              <div className="question-degree-div">
                <button className="lesson-delete-button delete-question" onClick={(e)=>{
                  e.stopPropagation();
                  deleteQuestion(qIndex);
                }}>حذف</button>
                <input
                type="number"
                min={1}
                className="grade-input"
                placeholder="درجة السؤال"
                value={q.grade ===0?null:q.grade}
                onChange={(e) => updateGrade(qIndex, e.target.value)}
              />
              <h4> درجة السؤال</h4>

              </div>
            </div>
        ))}
      </div>
      <button className="new-question-button" onClick={addQuestion}>سؤال جديد</button>
      { showMessage && (
                    <div className="overlay">
                        <div className="home-owner-message">
                            <p>{message}</p>
                            <button onClick={() => {setShowMessage(false);navigate(-1);}}>اغلاق</button>
                        </div>
                    </div>
            )}

      {capacityExceeded&&(
            <div className="overlay">
                {isAdmin&&(
                  <div className="subscribe-form">
                    <h3>برجاء الترقية لمتابعة نشر الاختبار</h3>
                    <div style={{display:"flex",justifyContent:"space-between",width:"100%",padding:"10px"}}>
                    <button onClick={()=>{setCapacityExceeded(false);navigate(-1);}}>إلغاء</button>
                    <button onClick={()=>navigate("/admin-home/plans")}>خطط الاسعار</button>
                    </div>
                  </div>
                )}
                {!isAdmin&&(
                  <div>
                    <h3>اطلب من المعلم الترقية لمتابعة نشر الدروس والاختبارات</h3>
                    <button onClick={()=>{setCapacityExceeded(false);navigate(-1);}}>إغلاق</button>
                  </div>
                )}
            </div>
        )}
    </div>
  );
}
